const doc = [({"ko":({"adminButtonHotelCalendar":({"deleteSpecifiedStaysOnlyPeriod":"박 수 한정 기간 삭제"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;